"use client"

import {useEffect} from "react";
import {getConfig} from "../../_configs/AppConfig";

const {publicRuntimeConfig} = getConfig();

export function ServiceWorkerManager(props) {
    useEffect(() => {
        if ('serviceWorker' in navigator && publicRuntimeConfig.APP_ENV !== "dev") {
            window.addEventListener('load', function() {
                navigator.serviceWorker
                    .register('/service-worker.js')
                    .catch(function(registrationError) {
                        console.error('SW registration failed: ', registrationError);
                    });
            });
        }
    }, []);

    return <></>
}